import {
  INVESTIGATION_HISTORY_PANEL_COLLAPSED_WIDTH_PX,
  INVESTIGATION_HISTORY_DRAWER_KEY,
  INVESTIGATION_HISTORY_PANEL_EXPANDED_WIDTH_PX,
} from "#src/routes/investigations/history/consts";
import { createTimelinePanelStore } from "@validereinc/common-components";

type InvestigationHistoryTimelinePanelStoreType = ReturnType<
  typeof createTimelinePanelStore
>;

let investigationHistoryTimelinePanelStore:
  | InvestigationHistoryTimelinePanelStoreType
  | undefined;

/**
 * Module-scoped TimelinePanel store so new/detail investigation routes share
 * open state and width without replaying mount animations on navigation.
 */
export const getInvestigationHistoryTimelinePanelStore = (
  initialIsOpen = true
): InvestigationHistoryTimelinePanelStoreType => {
  if (!investigationHistoryTimelinePanelStore) {
    investigationHistoryTimelinePanelStore = createTimelinePanelStore({
      isOpen: initialIsOpen,
      targetDrawer: INVESTIGATION_HISTORY_DRAWER_KEY,
      drawerWidth: initialIsOpen
        ? INVESTIGATION_HISTORY_PANEL_EXPANDED_WIDTH_PX
        : INVESTIGATION_HISTORY_PANEL_COLLAPSED_WIDTH_PX,
    });
  }

  return investigationHistoryTimelinePanelStore;
};
